module.exports = __webpack_public_path__ + "img/shape-7.ee6dbb07.png";